import { render, staticRenderFns } from "./older-service.vue?vue&type=template&id=e0a91190&scoped=true&"
import script from "./older-service.vue?vue&type=script&lang=js&"
export * from "./older-service.vue?vue&type=script&lang=js&"
import style0 from "./older-service.vue?vue&type=style&index=0&id=e0a91190&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0a91190",
  null
  
)

export default component.exports